import { Controller } from "@hotwired/stimulus"

// Slide-up "More" menu for the mobile bottom nav. Holds the secondary
// destinations that don't fit in the primary nav slots so mobile users still
// reach every entry the desktop sidebar exposes.
export default class extends Controller {
  static targets = ["sheet", "backdrop"]

  connect() {
    this.boundEsc = this.handleEsc.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEsc)
    document.body.classList.remove("mobile-more-locked")
  }

  open(event) {
    event?.preventDefault()
    this.sheetTarget.classList.add("mobile-more-sheet--open")
    this.backdropTarget.classList.add("mobile-more-backdrop--open")
    this.sheetTarget.setAttribute("aria-hidden", "false")
    document.body.classList.add("mobile-more-locked")
    document.addEventListener("keydown", this.boundEsc)
  }

  close(event) {
    event?.preventDefault()
    this.sheetTarget.classList.remove("mobile-more-sheet--open")
    this.backdropTarget.classList.remove("mobile-more-backdrop--open")
    this.sheetTarget.setAttribute("aria-hidden", "true")
    document.body.classList.remove("mobile-more-locked")
    document.removeEventListener("keydown", this.boundEsc)
  }

  handleEsc(event) {
    if (event.key === "Escape") this.close()
  }
}
